import React from "react";
import usePlanningWriteActivity from "../hooks/usePlanningWriteActivity.js";

export default function PlanningWriteActivityNotice() {
  const message = usePlanningWriteActivity();
  return message ? <p role="status" className="rounded-[4px] border border-line-soft bg-surface-muted px-2 py-1 text-xs text-content-copy" data-planning-write-notice>
    {message}. Attendez la fin pour enregistrer une autre modification.
  </p> : null;
}
